import { ActionButtonProps, Box, BoxProps, ColorOptions, Form } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { RefCalback } from '@jfs/ui-new/src/comps/Form/types'
import { FC, useEffect, useRef } from 'react'
import { GradientButton } from '../../components/GradientButton'
import { useLazyApiData, useStores } from '../../data/store'
import { formData } from './formData'

interface AddNewEntityProps {
  hide?: boolean
  initialData?: any
  id?: string
  onUpdate?: () => void
  onClose?: () => void
  selectedArr?: any
}
const AddNewEntity: FC<AddNewEntityProps> = ({
  hide = true,
  initialData = {},
  id,
  onUpdate,
  onClose,
  selectedArr,
}: AddNewEntityProps) => {
  const formref = useRef<RefCalback>(null)
  const { addEntity, update, message } = useStores((store) => ({
    addEntity: store.entityMaster.addEntity,
    accessConfig: store.user.accessConfig,
    user: store.user,
    update: store.entityMaster.updateEntity,
    message: store.message.getFormMessage(),
  }))

  console.log({ initialData })

  const [lazyAddEntity, lazyAddEntityHandler] = useLazyApiData(addEntity)
  const [lazyUpdateEntity, lazyUpdateEntityHandler] = useLazyApiData(update)

  useEffect(() => {
    if (lazyAddEntityHandler.state === 'fulfilled') {
      console.log('added')
      onUpdate && onUpdate()
    }
    if (lazyAddEntityHandler.state === 'rejected') {
      console.log('error add')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyAddEntityHandler])

  useEffect(() => {
    if (lazyUpdateEntityHandler.state === 'fulfilled') {
      console.log('added')
      onUpdate && onUpdate()
    }
    if (lazyUpdateEntityHandler.state === 'rejected') {
      console.log('error add')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyUpdateEntityHandler])

  if (!hide) {
    return null
  }

  const newEntity = (values: any) => {
    console.log({ values })
    lazyAddEntity(values)
  }

  const updateEntity = ({ name, status, subType, type }: any) => {
    lazyUpdateEntity({ name, entityStatus: status, subType, type, id })
  }

  const handleActions = ({ values, title, defaultActionButtonOnSubmit, isValid }: ActionButtonProps) => {
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box pv={16} justify={'center'} align={title === 'Update' ? 'flex-end' : 'center'}>
        <GradientButton
          hide={title === 'Update'}
          title={title}
          onPress={handleOnPress}
          height={40}
          width={300}
          testID={'btn-add-update-entity'}
          disabled={!isValid}
          isLoading={lazyAddEntityHandler.state === 'pending' || lazyUpdateEntityHandler.state === 'pending'}
        />
        <ButtonNew
          hide={title !== 'Update'}
          title={title}
          onPress={handleOnPress}
          height={40}
          icon={'UPLOAD'}
          color={'GREEN'}
          textType={'bodyMedium14'}
          underlayColor={'AVAILABLE_GREEN'}
          hoverColor={'AVAILABLE_GREEN'}
          disabled={!isValid}
          isLoading={lazyAddEntityHandler.state === 'pending' || lazyUpdateEntityHandler.state === 'pending'}
        />
      </Box>
    )
  }

  const goBack = () => {
    if (formref) {
      formref?.current?.goBack()
    }
  }

  return (
    <Box onPress={() => {}} {...styles.container} minHeight={selectedArr?.length > 0 ? 280 : 350}>
      <Form
        formData={formData(goBack, newEntity, id, updateEntity, message, selectedArr)}
        actionButtons={handleActions}
        ref={formref}
        initialValues={initialData}
      />
    </Box>
  )
}

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}
const styles = {
  container: {
    underlayColor: 'WHITE',
    overflow: 'auto',
    bg: 'WHITE',
    padding: 'MEDIUM',
    backgroundColor: 'WHITE',
    minWidth: 300,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#e3e6f0' as ColorOptions,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    ...shadow,
  } as BoxProps,
}

export { AddNewEntity }
